import { fetchRequest } from '@tk/utilities/tk.fetch';
import TKMinibasket from '@tk/components/tk.minibasket';

interface AmountResponse {
    amount: string;
    currency: string;
}

export default class DIWMinibasket extends TKMinibasket {
    amountRequestURL?: string;
    amountDisplay?: HTMLSpanElement;
    amountEmptyClass: string;
    priceVisible: boolean;

    constructor() {
        super();

        this.amountRequestURL = this.getAttribute('data-tk-amount-request-url') || undefined;
        this.amountDisplay = this.querySelector('[data-tk-amount-info]') || undefined;
        this.amountEmptyClass = this.getAttribute('data-tk-amount-empty-class-name') || 'tk-button__amount--empty';
        this.priceVisible = this.getAttribute('data-tk-price-visible') !== '0';
    }

    connectedCallback(): void {
        super.connectedCallback();
        this.fetchAmount();
    }

    fetchAmount(): void {
        fetchRequest({
            requestURL: this.amountRequestURL!,
            resolveHandler: this.setAmount.bind(this),
        });
    }

    setAmount(response: TKResponse<AmountResponse>) {
        if (!response || !response.success) return;

        const { amount, currency } = response.dataAsJson;

        if (parseInt(amount) === 0 || !this.priceVisible) {
            this.amountDisplay?.classList.add(this.amountEmptyClass);
        } else {
            this.headerButton?.setAttribute('data-amount', `${currency} ${amount || 0}`);
            this.amountDisplay?.classList.remove(this.amountEmptyClass);
            if (this.amountDisplay) {
                this.amountDisplay.textContent = `${currency} ${amount}`;
            }
        }
    }

    update(): void {
        this.fetchAmount();
        this.fetchQuantity();
        this.fetchAll();
    }
}
